import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { ModalHeader as EmbarkModalHeader, Modal } from '@emburse/ui-core';
import { CardStatementUploadWizardStart } from '@ReactComponents/BulkUploadWizardStart';
import { ProgressBar } from '@ReactComponents/ProgressBar';
import { Wizard } from '@ReactComponents/Wizard/Wizard';
import { ConnectedManualUploadCardProgramCardMapping } from './components/ManualUploadCardProgramCardMapping';
import { ManualUploadCardProgramCreate } from './components/ManualUploadCardProgramCreate';
import { ConnectedManualUploadCardProgramSummary } from './components/ManualUploadCardProgramSummary';
export class ManualUploadCardProgramModal extends React.Component {
    static getDerivedStateFromProps(props, lastState) {
        if (!lastState.initialized) {
            if (!props.firstPanel) {
                return {
                    headerText: 'Add Corporate Card Program',
                    isCreatingCardProgram: true,
                    currentPageId: 'createProgram',
                    initialized: true
                };
            }
            return {
                headerText: 'Upload Transactions',
                cardProgram: props.cardProgram,
                isCreatingCardProgram: false,
                initialized: true
            };
        }
        return null;
    }
    constructor(props) {
        super(props);
        this.state = { initialized: false };
    }
    onPanelChange(nextPanel) {
        this.setState({
            currentPageId: nextPanel
        });
        if (nextPanel !== 'createProgram') {
            this.setState({
                headerText: 'Upload Transactions'
            });
        }
        else {
            this.setState({
                headerText: 'Add Corporate Card Program'
            });
        }
    }
    /**
     * Renders the progress bar section and header for the current panel
     * @param currentPageId - the id of the current page
     * @param pages - a collection of pages
     */
    renderProgressBarSection(currentPageId, pages) {
        let sectionHeader;
        switch (currentPageId) {
            case 'createProgram':
                sectionHeader = 'Program Info';
                break;
            case 'start':
                sectionHeader = 'Statement Upload';
                break;
            case 'card_mapping':
                sectionHeader = 'Card Holders';
                break;
            case 'summary': // this might be a little misleading as it's not read only, transactions-select maybe?
                sectionHeader = 'Import Transactions';
                break;
        }
        return (_jsxs("div", Object.assign({ className: "section-header" }, { children: [_jsx("div", Object.assign({ className: "section-header-label" }, { children: sectionHeader })), _jsx("div", Object.assign({ className: "progress-bar" }, { children: _jsx(ProgressBar, { pages: pages, currentPageId: currentPageId }) }))] })));
    }
    render() {
        const { closeModal, firstPanel } = this.props;
        const { headerText, cardProgram } = this.state;
        const panelComponents = {
            createProgram: ManualUploadCardProgramCreate,
            start: CardStatementUploadWizardStart,
            summary: ConnectedManualUploadCardProgramSummary,
            card_mapping: ConnectedManualUploadCardProgramCardMapping,
            preview: null,
            applying: null
        };
        const pages = [
            { id: 'createProgram' },
            { id: 'start' },
            { id: 'card_mapping' },
            { id: 'summary' }
        ];
        const progressBarSection = this.state.isCreatingCardProgram ? this.renderProgressBarSection(this.state.currentPageId, pages) : null;
        const embarkModalHeader = _jsx(EmbarkModalHeader, { title: headerText, onCloseClicked: closeModal });
        return (_jsxs(Modal, Object.assign({ open: true, onClose: closeModal, modalHeader: embarkModalHeader, style: { width: 800, margin: '0 auto', maxWidth: '80%', minWidth: 500 } }, { children: [progressBarSection, _jsx(Wizard, { firstPanel: firstPanel || 'createProgram', uploadType: "card_statement", cardProgram: cardProgram, panelComponents: panelComponents, onSuccess: this.props.onSuccess, onFailure: this.props.onFailure, onPanelChange: (nextPanel) => this.onPanelChange(nextPanel), onReceiveProgram: (program) => this.setState({ cardProgram: program }) })] })));
    }
}
